import { NATURAL_WOODS, WOODS } from '@/components/Editor/WoodMap/options';

export { FRAME_WOODS, NATURAL_WOODS, WOODS, woodById } from '@/components/Editor/WoodMap/options';

// ids 7–8 are new stains for water / light frames; existing wood ids stay unchanged
export const TOPO_WOODS = [
    ...WOODS,
    { id: 7, name: 'Fehér', labelKey: 'editor.wood.white', color: '#f3efe6' },
    { id: 8, name: 'Azúr', labelKey: 'editor.wood.azure', color: '#1570c4' },
];

export const WATER_WOODS = TOPO_WOODS.filter((wood) => [6, 7, 8, 1].includes(wood.id));
export const TOPO_FRAME_WOODS = TOPO_WOODS.filter((wood) => [1, 4, 5, 7].includes(wood.id));

export const LAYER_COUNTS = [6, 8, 10, 12];

// one editor, two pages; city: zoom 14 fetches about 35 building tiles (z15) and a house is ~2 mm on the board
export const TOPO_MODES = [
    {
        id: 'terrain',
        labelKey: 'editor.topo_map.mode_terrain',
        titleKey: 'editor.topo_map.title',
        subtitleKey: 'editor.topo_map.subtitle',
        minZoom: 5,
        maxZoom: 13,
    },
    {
        id: 'city',
        labelKey: 'editor.topo_map.mode_city',
        titleKey: 'editor.city_map.title',
        subtitleKey: 'editor.city_map.subtitle',
        minZoom: 14,
        maxZoom: 17,
        placeTypes: 'place,locality,neighborhood',
    },
];

export const WATER_STYLES = [
    { id: 'flat', labelKey: 'editor.topo_map.water_flat' },
    { id: 'bathymetry', labelKey: 'editor.topo_map.water_bathymetry' },
];

export const TOPO_LAYERS = [
    { key: 'landWood', labelKey: 'editor.wood_layer.land', options: NATURAL_WOODS },
    { key: 'waterWood', labelKey: 'editor.wood_layer.water', options: WATER_WOODS },
    { key: 'frameWood', labelKey: 'editor.frame.label', options: TOPO_FRAME_WOODS },
];

export const topoWoodById = (id) => TOPO_WOODS.find((wood) => wood.id === id) || TOPO_WOODS[0];
